import { STORAGE_KEYS } from '@/constants/storage';

const WORKSPACE_SCOPE_READY_KEY = 'fattahone_workspace_scope_ready';

/** Drop persisted company/store selection (safe when switching accounts or orgs). */
export function clearWorkspaceScopeStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEYS.SELECTED_COMPANY);
    localStorage.removeItem(STORAGE_KEYS.SELECTED_STORE);
    sessionStorage.removeItem(WORKSPACE_SCOPE_READY_KEY);
  } catch {
    /* ignore */
  }
}

/** Allow API client to send X-Company-Id / X-Store-Id after explicit user selection. */
export function markWorkspaceScopeReady(): void {
  try {
    sessionStorage.setItem(WORKSPACE_SCOPE_READY_KEY, 'true');
  } catch {
    /* ignore */
  }
}
